module.exports = __webpack_public_path__ + "media/images/icons/facebook-dark-5bb58a27ae1190c15c06854d38381765.png";